import Consultation from "./user";

Consultation.prototype.processScore = function (survey, varDict, scores, scoreName) {
    var that = this;
    var $percentage = that.calculateScore(varDict, survey, scores, scoreName);
    if(!isNaN($percentage)) {
        return Math.round($percentage,0);
    }
    return 0;
}

Consultation.prototype.processAnswersScores = function (varDict, survey) {
    var that = this;
    var scores = {};
    scores.diet = that.processScore(survey, varDict, this.scores, "Diet");
    scores.lifestyle = that.processScore(survey, varDict, this.scores, "Lifestyle");
    return scores;
}

Consultation.prototype.processGoalsFocus = function(varDict, products) {
    var $focusGoal = "not found";
    var $finalGoal = null;
    // look for *GoalPriority true in varDict  
    jQuery.each(varDict, function (k, v) {
        if (v && k.match(/GoalPriority$/)) $focusGoal = k.replace("GoalPriority", "");
    });

    if($focusGoal != "not found") {
        // Do any of the products have this as a goal?
        jQuery.each(products, function(i, reason) {
            jQuery.each(reason, function(i, product) {
                jQuery.each(product['relatedgoals'], function(ii, relatedgoal) {
                    if(relatedgoal == $focusGoal) {
                        $finalGoal = $focusGoal;
                    }
                });
            });
        });
    }

    if ($finalGoal) {
        return $finalGoal;
    }
    return $focusGoal;
}

Consultation.prototype.processGoalsOther = function (varDict, products, focusgoal) {

    var that = this;
    var $otherGoals = [];
    // pull goals from products recommended cross referenced wiuth varDict
    jQuery.each(products, function (productName, productInfo) {
        // console.log("processGoalsOther", productName, productInfo[0], productInfo[0].relatedgoals);
        jQuery.each(productInfo[0].relatedgoals, function (i, goalName) {
            // console.log(goalName);
            if (goalName) {
                var $minGoalname = goalName.replace("Goal", "");
                if ($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                    $otherGoals.push($minGoalname);
                }
            }
            /*
            if(varDict[goalName]) {
              console.log("isTrue", goalName);
              var $minGoalname = goalName.replace("Goal", "");
              if($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                console.log("not in list, add", $minGoalname);
                $otherGoals.push($minGoalname);
              }
            }
            */
        });
    });

    jQuery.each(that.cachedOtherGoalsThatWereCut, function(i, goalName) {
        if(goalName) {
            var $minGoalname = goalName.replace("Goal", "");
            if($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                $otherGoals.push($minGoalname);
            }
        }
    });

    // jQuery("#goalsOther").html(
    //     "<div class='text-center'>Other Goals<br /><b>" + $otherGoals.join(", ") + "</b></div>"
    // );

    return $otherGoals;
}

Consultation.prototype.setMainGoalIfOnlyOneGoal = function(varDict) {
  // count how many *Goal and *PriorityGoal truths there are.
  // If it's 1 *Goal and 0 *PriorityGoal then set the *PriorityGoal
  // But what happens if they select another one? Do we disable all *PriorityGoals?
  var numGoals = 0;
  var numPriorityGoals = 0;
  var lastGoalName = '';
  jQuery.each(varDict, function(k, v) {
    if(v) {
      if(k.match(/GoalPriority$/)) {
        // console.log(k)
        numPriorityGoals++;
      } else if(k.match(/Goal$/)) {
        // console.log(k)
        numGoals++;
        lastGoalName = k;
      }
    }
  });

  // console.log(numGoals, numPriorityGoals);

  if(numGoals == 1 && numPriorityGoals == 0) {
    // console.log(lastGoalName.replace(/Goal$/,"GoalPriority"));
    varDict[ lastGoalName.replace(/Goal$/,"GoalPriority") ] = true;
  }
  // console.log(varDict);
  return varDict;
}

Consultation.prototype.processGoals = function (varDict, products) {
    // jQuery("#goalsContainer").html(
    //     "<div class='row top-buffer'><div id='goalsFocus' class='col-sm-6' /><div id='goalsOther' class='col-sm-6' /></div>"
    // );

    var $focusGoal = this.processGoalsFocus(varDict, products)
    var $otherGoals = this.processGoalsOther(varDict, products, $focusGoal)

    return {focusGoal: $focusGoal, otherGoals: $otherGoals};
}

Consultation.prototype.displayName = function (survey) {
    var q = survey.getQuestionByName("name");
    return q.value;
}

Consultation.prototype.replaceProducts = function (products) {

    var replacedProducts = {};

    var count = 0;
    jQuery.each(products, function (k, product) {
        count++;
        switch (count) {
            case 1:
                replacedProducts["Calcium"] = product;
                break;
            case 2:
                replacedProducts["Omega 3 + D3"] = product;
                break;
        }
    });

    return replacedProducts;
}

Consultation.prototype.processAllergiesAndDiet = function(varDict) {
//   $('#allergiesAndDietContainer').html("<div class='row text-center top-buffer'><div class='col-sm-6' id='allergiesContainer' /><div class='col-sm-6' id='dietContainer' /></div>");

  var allergies = [];
  var diets = [];
  jQuery.each(varDict, function(varName, varVal) {
    if(varVal && varName.startsWith("FoodAllergies") && varName != 'FoodAllergiesNone') {
      var name = varName.replace('FoodAllergies', '') + '-Free';
      allergies.push(name);

    }

    if(varVal && varName.startsWith("Diet") && varName != 'DietNone') {
        var name = varName.replace('Diet', '').replace('Free', '-Free');
        if(jQuery.inArray(name, allergies) == -1) {
            diets.push(name);
        }
    }
  });

  return {allergen_info: allergies, dietary_restrictions: diets};

}

Consultation.prototype.surveyCompleteProcessAnswers = function (survey) {
    // console.log('surveyCompleteProcessAnswers');
    // clear survey and prepare the screen for results.
    var varDict = this.convertQuestionnaireOutputToVarDict(survey.data);
    varDict = this.setMainGoalIfOnlyOneGoal(varDict);
    var products = this.processProducts(varDict, survey, this.MaxCapsules);
    // below line for testing with hardcoded products only
    // products = this.replaceProducts(products);
    var scores = this.processAnswersScores(varDict, survey);
    varDict = this.addDietAndLifestyleBandVariables(varDict, scores);
    var goals = this.processGoals(varDict, products);
    var name = this.displayName(survey);
    var dietary_requirements = this.processAllergiesAndDiet(varDict);
    var extraData = {
        'ScoreDiet': scores.diet ? scores.diet : 0,
        'ScoreLifestyle': scores.lifestyle ? scores.lifestyle : 0
    };
    var reports = this.processHealthReports(varDict, extraData);

    return {
        // responses: varDict,
        products: products,
        scores: scores,
        goals: goals,
        name: name,
        dietary_requirements: dietary_requirements,
        reports: reports
    }

    // $.ajax({
    //   type: "POST",
    //   url: "save_survey.php",
    //   data: {
    //     responses: varDict,
    //     products: products
    //   },
    //   success: function() {
    //     alert("Saved!");
    //   },
    //   dataType: "json"
    // });
}

Consultation.prototype.calculateScore = function(varDict, survey, scores, scoreName) {
  var min = 0;
  var max = 0;
  var numAnswers = 0;
  var totalScore = 0;

  var answers = survey.data;
  var questions = survey.getAllQuestions(true); // don't include invisible questions
  jQuery.each(questions, function(i, question) {
    jQuery.each(question.choices, function(k, v) {
      if (scores[scoreName]) {
        var $choiceScore = scores[scoreName][ v['itemValue'] ];
        if($choiceScore) {
            // console.log(v, varDict[v['itemValue']], $choiceScore);
            if($choiceScore > max) max = $choiceScore;
            if($choiceScore < min) min = $choiceScore;
            if(varDict[v['itemValue']] && $choiceScore != 0) {
            numAnswers++;
            totalScore+=$choiceScore;
            }
        }
      }
    });
  });
  var avg = totalScore / numAnswers;
  var onePercent = (max - min) / 100;
  var percentage = (avg - min) / onePercent;
  // console.log(min,max,numAnswers,totalScore,avg,percentage);
  return 50 + (percentage / 2);
}

Consultation.prototype.processProducts = function (varDict, survey, maxCapsules) {
    var that = this;
    var products = this.findMatchingProducts(varDict, this.truth_table);
    // console.log("after findMatchingProducts", products);
    products = this.removeExclusions(products, this.truth_table);
    // console.log("after removeExclusions", products);
    products = this.removeAllButTheHighestPriorityProductsCappedAtEightCapsules(products, this.truth_table, maxCapsules);
    // console.log("after removeAllButTheHighestPriorityProductsCappedAtEightCapsules", products);
    return products;
}

Consultation.prototype.removeAllButTheHighestPriorityProductsCappedAtEightCapsules = function (products, truthTablem, maxCapsules) {

    var that = this;

    // first we remove all but the highest priority reasons for each product.
    jQuery.each(products, function (k, product) {
        // sort by priority (lower is higher)
        products[k] = product.sort(function (a, b) {
            return a.priority - b.priority;
        });
        products[k].length = 1; // truncate to first item
    });

    // annotate name into products so we can sort the values
    // without losing the key.
    var productsAsList = [];
    jQuery.each(products, function (k, product) {
        products[k][0]['_Name'] = k;
        productsAsList.push(products[k]);
    });

    // sort product list by priority (of remaining reason, should only be 1 now)
    productsAsList = productsAsList.sort(function (a, b) {
        return a[0].priority - b[0].priority;
    });

    // console.log("ORD", productsAsList);

    // now it's in order pull out products until we have
    // no space for any more capsules.
    products = {};
    this.cachedOtherGoalsThatWereCut = [];
    jQuery.each(productsAsList, function (i, product) {
        if (product[0].capsules <= maxCapsules) {
            maxCapsules -= product[0].capsules;
            products[product[0]['_Name']] = product;
        } else {
            // NOTE: we cache all of the Related/Other Goals from the
            // prods we're cutting so we can include them later.
            jQuery.each(product[0].relatedgoals, function(i, v) {
                if(v) {
                // console.log(v);
                    if(that.cachedOtherGoalsThatWereCut.indexOf(v) == -1) {
                        that.cachedOtherGoalsThatWereCut.push(v);
                    }
                }
            });
        }
    });

    // console.log(that.cachedOtherGoalsThatWereCut);

    // console.log("CAP", products);

    return products;
}

Consultation.prototype.getCombineGroupLookup = function (truthTable) {
    var combineGroupLUT = {};
    jQuery.each(truthTable, function (productName, data) {
        var combineGroupNamesList = data['_CombineWith'];
        jQuery.each(combineGroupNamesList, function (_, combineGroupName) {
            if (!combineGroupLUT[combineGroupName]) {
                combineGroupLUT[combineGroupName] = [productName];
            } else {
                combineGroupLUT[combineGroupName].push(productName);
            }
        });
    });
    return combineGroupLUT;
}

Consultation.prototype.combineProducts = function (products, truthTable) {
    var combineGroupLUT = this.getCombineGroupLookup(truthTable);
    // console.log(combineGroupLUT);

    // look at each group. if all products in a group
    // have been selected then combine them into one product.
    jQuery.each(combineGroupLUT, function (combineGroupName, productsInGroup) {
        // console.log(combineGroupName +" "+ productsInGroup);
        var allProductsSelected = true;
        jQuery.each(productsInGroup, function (_, productInGroupName) {
            if (!products[productInGroupName]) {
                allProductsSelected = false;
            }
        });
        if (allProductsSelected) {
            // console.log("Combine group '" + combineGroupName + "' HAS all its products selected. Merging them.");
            var combinedReasons = [];
            jQuery.each(productsInGroup, function (_, productInGroupName) {
                jQuery.each(products[productInGroupName], function (_, reason) {
                    combinedReasons.push(productInGroupName + " as " + reason);
                });
                delete products[productInGroupName];
            });
            products[combineGroupName] = combinedReasons;
        } else {
            // console.log("Combine group '" + combineGroupName + "' does NOT have all its products selected.");
        }
    });

    return products;
}

Consultation.prototype.removeExclusions = function (products, truthTable) {
  var productsMinusExclusions = {};
  jQuery.each(products, function(productName, reasons) {
    var unexcluded_reasons = [];
    jQuery.each(reasons, function(i, reason) {
      var excludeIfWithList = reason['excludeifwith'];
      // are ANY of the named products also selected? if so, exclude this one.
      var excluded=false;
      jQuery.each(excludeIfWithList, function(_, excludeIfWith) {
        if(products[excludeIfWith]) {
          excluded = true;
          // console.log("Excluded "+productName+" as ExcludeIfWith "+excludeIfWith);
        }
      });
      if(!excluded) {
        unexcluded_reasons.push(reason);
      }
    });
    if(unexcluded_reasons && unexcluded_reasons.length > 0) {
      productsMinusExclusions[productName] = unexcluded_reasons;
    }
  });
  return productsMinusExclusions;
}

Consultation.prototype.processVarNameAndValue = function (varDict, truthVar, truthVal) {
    // Turn our TT varname of "Var1 and (Var2 or Var3)" into some JS we can eval.
    // Most of the time it'll likely be just a single name that matches the varDict.
    // console.log("START processVarNameAndValue", truthVar);
    if (!truthVar) return;
    truthVar = String(truthVar).replace(/[a-zA-Z0-9+-]+/g, function (varName) {
        // console.log("REPLACE processVarNameAndValue", varName);
        var replaceVal;
        if (varName == 'or') {
            replaceVal = '||';
        } else if (varName == 'and') {
            replaceVal = '&&';
        } else {
            replaceVal = varDict[varName] ? 'true' : 'false';
        }
        // console.log("REPLACE processVarNameAndValue", varName, replaceVal);
        return replaceVal;
    });
    // console.log("MID processVarNameAndValue", truthVar);
    var response = eval(truthVar) == truthVal;
    // console.log("END processVarNameAndValue", response);
    return response;
}

Consultation.prototype.findMatchingProducts = function (varDict, truthTable) {
    var products = {};
    var that = this;
    jQuery.each(truthTable, function (productName, truthOptions) {
        jQuery.each(truthOptions, function (reason, truth) {
            var viable = true;
            // console.log(productName+" "+reason);
            var priority = truth['_Priority'];
            var capsules = truth['_Capsules'];
            var excludeifwith = truth['_ExcludeIfWith'];

            // give the priority a boost if this product is in 
            // a focus goal area.
            var relatedgoals = truth['_RelatedGoals'];
            var focusgoals = truth['_FocusGoals'];
            var hasFocusGoal = false;
            jQuery.each(focusgoals, function (i, goalVarName) {
                if (varDict[goalVarName]) hasFocusGoal = true;
            });
            if (hasFocusGoal) {
                priority -= 30;
            }

            // console.log(truth);
            jQuery.each(truth, function (truthVar, truthVal) {
                if (truthVar[0] != "_") {
                    if(!that.processVarNameAndValue(varDict, truthVar, truthVal)) {
                        viable = false;
                    }
                }
            });
            if (viable) {
                // console.log("Product selected: " + productName);
                if (!products[productName]) {
                    products[productName] = [];
                }
                products[productName].push({ "reason": reason, "priority": priority, "capsules": capsules, "relatedgoals": relatedgoals, "excludeifwith":excludeifwith });
            }
        });
    });
    return products;
}

Consultation.prototype.summarizeProducts = function (products) {
    var text = "";
    jQuery.each(products, function (product, reasons) {
        text += "<div class='row top-buffer'>";
        text += "<ul class='col-sm list-group'>";
        text += "<li class='list-group-item active'>" + product + "</li>";
        jQuery.each(reasons, function (_i, info) {
            text += "<li class='list-group-item'>" + info['reason'] + " <small>[ DEBUG: priority: " + info['priority'] + " capsules: " + info['capsules'] + " relatedgoals: " + info['relatedgoals'] + " ]</small></li>";
        });
        text += "</ul>";
        text += "</div>";
    });
    return text;
}

Consultation.prototype.updateMaxCapsules = function(options) {
  // side effect to manage MaxCapsulesN only being set to the last
  // one selected.
  if(options && options.value && typeof options.value == 'string' && options.value.startsWith('MaxCapsules')) {
    // console.log(options.value);
    this.MaxCapsules = parseInt(options.value.replace('MaxCapsules', ''));
    // console.log(MaxCapsules);
  }
}

export default Consultation;


// WEBPACK FOOTER //
// ./js/components/consultation/results.js